/* eslint-disable */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.no_genotype_age_oth_spline = exports.no_genotype_genotype_scd_spline = exports.no_genotype_syncope_scd_spline = exports.no_genotype_nsvt_scd_spline = exports.no_genotype_age_scd_spline = exports.no_genotype_grad_scd_spline = exports.no_genotype_la_scd_spline = exports.no_genotype_lvpwd_scd_spline = exports.no_genotype_ivsd_scd_spline = void 0;
function no_genotype_ivsd_scd_spline(x) {
    let value = -0.1719752 +
        0.0095584661 * x +
        +0.00059326221 * Math.max(x - 2.1238109, 0) ** 3 -
        0.0010151615 * Math.max(x - 3.1601452, 0) ** 3 +
        0.00075740801 * Math.max(x - 4.1964794, 0) ** 3 -
        0.00052619578 * Math.max(x - 5.2328137, 0) ** 3 +
        0.00021416819 * Math.max(x - 6.269148, 0) ** 3 -
        0.00011679878 * Math.max(x - 7.3054823, 0) ** 3 +
        5.4269628e-5 * Math.max(x - 8.3418166, 0) ** 3 -
        8.0894406e-5 * Math.max(x - 9.3781509, 0) ** 3 +
        2.6776315e-5 * Math.max(x - 10.414485, 0) ** 3 -
        1.5420039e-5 * Math.max(x - 11.450819, 0) ** 3 +
        1.8179375e-5 * Math.max(x - 12.487154, 0) ** 3 +
        4.7685688e-6 * Math.max(x - 13.523488, 0) ** 3 -
        4.4384636e-6 * Math.max(x - 14.559822, 0) ** 3 +
        9.7867605e-6 * Math.max(x - 15.596157, 0) ** 3 +
        5.688403e-5 * Math.max(x - 16.632491, 0) ** 3 +
        3.4342318e-6 * Math.max(x - 17.668825, 0) ** 3 -
        1.67964e-5 * Math.max(x - 18.705159, 0) ** 3 +
        6.9468377e-5 * Math.max(x - 19.741494, 0) ** 3 +
        5.450879e-5 * Math.max(x - 20.777828, 0) ** 3 -
        1.6772112e-5 * Math.max(x - 21.814162, 0) ** 3 +
        7.0124764e-6 * Math.max(x - 22.850497, 0) ** 3 +
        2.1331621e-6 * Math.max(x - 23.886831, 0) ** 3 -
        3.2612304e-6 * Math.max(x - 24.923165, 0) ** 3 +
        1.0373722e-5 * Math.max(x - 25.959499, 0) ** 3 -
        3.7393924e-5 * Math.max(x - 26.995834, 0) ** 3 -
        4.4130474e-5 * Math.max(x - 28.032168, 0) ** 3 +
        1.3229505e-5 * Math.max(x - 29.068502, 0) ** 3 -
        7.2795609e-6 * Math.max(x - 30.104837, 0) ** 3 +
        6.1515528e-6 * Math.max(x - 31.141171, 0) ** 3 -
        6.0109449e-6 * Math.max(x - 32.177505, 0) ** 3 +
        9.050903e-6 * Math.max(x - 33.213839, 0) ** 3 -
        1.5117855e-5 * Math.max(x - 34.250174, 0) ** 3 +
        3.377287e-5 * Math.max(x - 35.286508, 0) ** 3 -
        5.805769e-5 * Math.max(x - 36.322842, 0) ** 3 +
        0.00010756232 * Math.max(x - 37.359177, 0) ** 3 -
        0.00022329268 * Math.max(x - 38.395511, 0) ** 3 +
        0.00030500188 * Math.max(x - 39.431845, 0) ** 3 -
        0.00042136726 * Math.max(x - 40.468179, 0) ** 3 +
        0.00025118619 * Math.max(x - 41.504514, 0) ** 3;
    return value;
}
exports.no_genotype_ivsd_scd_spline = no_genotype_ivsd_scd_spline;
function no_genotype_lvpwd_scd_spline(x) {
    let value = -0.027004954 +
        0.011195731 * x -
        6.8557693e-5 * Math.max(x + 2.0704811, 0) ** 3 +
        0.00011854387 * Math.max(x + 1.2953533, 0) ** 3 -
        8.6817774e-5 * Math.max(x + 0.52022546, 0) ** 3 +
        4.8161685e-5 * Math.max(x - 0.25490235, 0) ** 3 -
        3.0935023e-5 * Math.max(x - 1.0300302, 0) ** 3 +
        1.6235797e-5 * Math.max(x - 1.805158, 0) ** 3 -
        8.6688756e-6 * Math.max(x - 2.5802858, 0) ** 3 +
        4.6415571e-6 * Math.max(x - 3.3554136, 0) ** 3 -
        2.4918127e-6 * Math.max(x - 4.1305414, 0) ** 3 +
        1.3480155e-6 * Math.max(x - 4.9056692, 0) ** 3 -
        7.4818395e-7 * Math.max(x - 5.680797, 0) ** 3 +
        4.5040065e-7 * Math.max(x - 6.4559248, 0) ** 3 -
        3.3578093e-7 * Math.max(x - 7.2310527, 0) ** 3 +
        3.6857401e-7 * Math.max(x - 8.0061805, 0) ** 3 -
        6.6481417e-7 * Math.max(x - 8.7813083, 0) ** 3 +
        1.2539256e-5 * Math.max(x - 9.5564361, 0) ** 3 +
        6.694915e-7 * Math.max(x - 10.331564, 0) ** 3 -
        2.7297155e-7 * Math.max(x - 11.106692, 0) ** 3 +
        1.3844041e-7 * Math.max(x - 11.88182, 0) ** 3 -
        7.4855658e-8 * Math.max(x - 12.656947, 0) ** 3 +
        4.3289963e-8 * Math.max(x - 13.432075, 0) ** 3 -
        2.9416363e-8 * Math.max(x - 14.207203, 0) ** 3 +
        2.7470098e-8 * Math.max(x - 14.982331, 0) ** 3 -
        3.6869316e-8 * Math.max(x - 15.757459, 0) ** 3 +
        6.3262374e-8 * Math.max(x - 16.532586, 0) ** 3 -
        1.329433e-7 * Math.max(x - 17.307714, 0) ** 3 +
        4.5385762e-7 * Math.max(x - 18.082842, 0) ** 3 +
        2.825631e-6 * Math.max(x - 18.85797, 0) ** 3 -
        1.2362917e-6 * Math.max(x - 19.633098, 0) ** 3 +
        1.7314106e-6 * Math.max(x - 20.408225, 0) ** 3 -
        2.9852091e-6 * Math.max(x - 21.183353, 0) ** 3 +
        5.4497048e-6 * Math.max(x - 21.958481, 0) ** 3 -
        1.0111043e-5 * Math.max(x - 22.733609, 0) ** 3 +
        1.8829846e-5 * Math.max(x - 23.508737, 0) ** 3 -
        3.4965962e-5 * Math.max(x - 24.283865, 0) ** 3 +
        6.3746251e-5 * Math.max(x - 25.058992, 0) ** 3 -
        0.00010672746 * Math.max(x - 25.83412, 0) ** 3 +
        0.00014481086 * Math.max(x - 26.609248, 0) ** 3 -
        8.5285693e-5 * Math.max(x - 27.384376, 0) ** 3;
    return value;
}
exports.no_genotype_lvpwd_scd_spline = no_genotype_lvpwd_scd_spline;
function no_genotype_la_scd_spline(x) {
    let value = -0.21805112 +
        0.047516419 * x +
        0.0093078902 * Math.max(x + 4.0063473, 0) ** 3 -
        0.016935438 * Math.max(x + 3.7812342, 0) ** 3 +
        0.012512384 * Math.max(x + 3.5561212, 0) ** 3 -
        0.0077411302 * Math.max(x + 3.3310082, 0) ** 3 +
        0.0041185853 * Math.max(x + 3.1058951, 0) ** 3 -
        0.0021751721 * Math.max(x + 2.8807821, 0) ** 3 +
        0.0010820931 * Math.max(x + 2.6556691, 0) ** 3 -
        0.00029264911 * Math.max(x + 2.430556, 0) ** 3 +
        0.0010388125 * Math.max(x + 2.205443, 0) ** 3 -
        0.00042894972 * Math.max(x + 1.98033, 0) ** 3 +
        0.00034161592 * Math.max(x + 1.7552169, 0) ** 3 -
        0.0004530398 * Math.max(x + 1.5301039, 0) ** 3 +
        0.0014570471 * Math.max(x + 1.3049909, 0) ** 3 +
        0.00090558632 * Math.max(x + 1.0798778, 0) ** 3 -
        0.00028835013 * Math.max(x + 0.8547648, 0) ** 3 +
        0.00013275668 * Math.max(x + 0.62965176, 0) ** 3 -
        5.4265851e-5 * Math.max(x + 0.40453873, 0) ** 3 -
        0.00011234727 * Math.max(x + 0.1794257, 0) ** 3 -
        5.5509775e-5 * Math.max(x - 0.045687336, 0) ** 3 +
        3.0398034e-5 * Math.max(x - 0.27080037, 0) ** 3 -
        2.5075571e-5 * Math.max(x - 0.4959134, 0) ** 3 +
        2.5634435e-5 * Math.max(x - 0.72102644, 0) ** 3 -
        0.00045747664 * Math.max(x - 0.94613947, 0) ** 3 +
        0.00016787124 * Math.max(x - 1.1712525, 0) ** 3 -
        0.00028858155 * Math.max(x - 1.3963655, 0) ** 3 +
        0.0005737415 * Math.max(x - 1.6214786, 0) ** 3 -
        0.0016059076 * Math.max(x - 1.8465916, 0) ** 3 -
        0.0042292393 * Math.max(x - 2.0717046, 0) ** 3 +
        0.0010017089 * Math.max(x - 2.2968177, 0) ** 3 -
        0.00068226512 * Math.max(x - 2.5219307, 0) ** 3 +
        0.00078135618 * Math.max(x - 2.7470437, 0) ** 3 -
        0.001633778 * Math.max(x - 2.9721568, 0) ** 3 +
        0.00024048835 * Math.max(x - 3.1972698, 0) ** 3 -
        0.0017523196 * Math.max(x - 3.4223828, 0) ** 3 +
        0.0035930259 * Math.max(x - 3.6474959, 0) ** 3 -
        0.0067820921 * Math.max(x - 3.8726089, 0) ** 3 +
        0.01325814 * Math.max(x - 4.0977219, 0) ** 3 -
        0.013752452 * Math.max(x - 4.322835, 0) ** 3 +
        0.009176904 * Math.max(x - 4.547948, 0) ** 3;
    return value;
}
exports.no_genotype_la_scd_spline = no_genotype_la_scd_spline;
function no_genotype_grad_scd_spline(x) {
    let value = 0.03126626 -
        0.002967774 * x +
        1.9395512e-6 * Math.max(x - 3.7485, 0) ** 3 -
        2.0214409e-6 * Math.max(x - 7.497, 0) ** 3 +
        3.2452346e-6 * Math.max(x - 11.2455, 0) ** 3 -
        1.2719091e-6 * Math.max(x - 14.994, 0) ** 3 -
        1.2470431e-7 * Math.max(x - 18.7425, 0) ** 3 -
        8.8556458e-7 * Math.max(x - 22.491, 0) ** 3 +
        4.1128411e-7 * Math.max(x - 26.2395, 0) ** 3 -
        2.6761851e-6 * Math.max(x - 29.988, 0) ** 3 +
        1.861422e-7 * Math.max(x - 33.7365, 0) ** 3 -
        2.949494e-7 * Math.max(x - 37.485, 0) ** 3 -
        3.7687407e-7 * Math.max(x - 41.2335, 0) ** 3 -
        1.5755578e-8 * Math.max(x - 44.982, 0) ** 3 +
        3.9381325e-7 * Math.max(x - 48.7305, 0) ** 3 +
        2.1273289e-7 * Math.max(x - 52.479, 0) ** 3 -
        4.6970192e-8 * Math.max(x - 56.2275, 0) ** 3 -
        8.0613377e-7 * Math.max(x - 59.976, 0) ** 3 +
        9.3334693e-8 * Math.max(x - 63.7245, 0) ** 3 -
        2.7626543e-7 * Math.max(x - 67.473, 0) ** 3 -
        2.0704704e-7 * Math.max(x - 71.2215, 0) ** 3 -
        3.3336145e-7 * Math.max(x - 74.97, 0) ** 3 +
        1.8101318e-6 * Math.max(x - 78.7185, 0) ** 3 +
        9.7428693e-7 * Math.max(x - 82.467, 0) ** 3 -
        3.5286429e-7 * Math.max(x - 86.2155, 0) ** 3 +
        1.4518211e-6 * Math.max(x - 89.964, 0) ** 3 -
        8.6538967e-8 * Math.max(x - 93.7125, 0) ** 3 +
        8.2417514e-8 * Math.max(x - 97.461, 0) ** 3 +
        1.4074831e-7 * Math.max(x - 101.2095, 0) ** 3 -
        9.3365891e-8 * Math.max(x - 104.958, 0) ** 3 +
        3.4059009e-7 * Math.max(x - 108.7065, 0) ** 3 +
        1.704081e-7 * Math.max(x - 112.455, 0) ** 3 -
        5.7955812e-8 * Math.max(x - 116.2035, 0) ** 3 -
        4.4915466e-7 * Math.max(x - 119.952, 0) ** 3 -
        3.3601658e-8 * Math.max(x - 123.7005, 0) ** 3 -
        3.7149094e-8 * Math.max(x - 127.449, 0) ** 3 -
        7.6023537e-7 * Math.max(x - 131.1975, 0) ** 3 +
        6.6188775e-7 * Math.max(x - 134.946, 0) ** 3 -
        1.1743111e-6 * Math.max(x - 138.6945, 0) ** 3 +
        9.8485466e-7 * Math.max(x - 142.443, 0) ** 3 -
        7.1690146e-7 * Math.max(x - 146.1915, 0) ** 3;
    return value;
}
exports.no_genotype_grad_scd_spline = no_genotype_grad_scd_spline;
function no_genotype_age_scd_spline(x) {
    let value = -0.24864109 -
        0.056752646 * x +
        0.0072648507 * Math.max(x - 0.45249005, 0) ** 3 -
        0.0096067153 * Math.max(x - 0.90224225, 0) ** 3 +
        0.0070744081 * Math.max(x - 1.3519944, 0) ** 3 -
        0.0050659281 * Math.max(x - 1.8017466, 0) ** 3 +
        0.0021085265 * Math.max(x - 2.2514988, 0) ** 3 -
        0.0018796947 * Math.max(x - 2.701251, 0) ** 3 +
        0.00025518588 * Math.max(x - 3.1510032, 0) ** 3 -
        0.00084580704 * Math.max(x - 3.6007554, 0) ** 3 -
        0.0008525365 * Math.max(x - 4.0505076, 0) ** 3 -
        2.0163686e-5 * Math.max(x - 4.5002598, 0) ** 3 -
        0.00090456457 * Math.max(x - 4.950012, 0) ** 3 +
        0.00026220773 * Math.max(x - 5.3997642, 0) ** 3 +
        0.00074300654 * Math.max(x - 5.8495164, 0) ** 3 -
        8.2120683e-5 * Math.max(x - 6.2992686, 0) ** 3 +
        0.0014409415 * Math.max(x - 6.7490208, 0) ** 3 +
        0.00010274299 * Math.max(x - 7.198773, 0) ** 3 -
        0.00011118759 * Math.max(x - 7.6485252, 0) ** 3 +
        9.6971335e-5 * Math.max(x - 8.0982774, 0) ** 3 -
        0.00057944958 * Math.max(x - 8.5480296, 0) ** 3 -
        0.00071840786 * Math.max(x - 8.9977818, 0) ** 3 +
        0.0011267962 * Math.max(x - 9.447534, 0) ** 3 +
        0.00061857851 * Math.max(x - 9.8972862, 0) ** 3 +
        0.00045409532 * Math.max(x - 10.347038, 0) ** 3 +
        0.0016700387 * Math.max(x - 10.796791, 0) ** 3 -
        0.00064876787 * Math.max(x - 11.246543, 0) ** 3 -
        0.00088696891 * Math.max(x - 11.696295, 0) ** 3 +
        6.6059614e-6 * Math.max(x - 12.146047, 0) ** 3 -
        0.0013022799 * Math.max(x - 12.595799, 0) ** 3 +
        3.0140968e-6 * Math.max(x - 13.045552, 0) ** 3 +
        0.00064755576 * Math.max(x - 13.495304, 0) ** 3 +
        0.00015066302 * Math.max(x - 13.945056, 0) ** 3 +
        5.0248324e-5 * Math.max(x - 14.394808, 0) ** 3 +
        0.00058617184 * Math.max(x - 14.84456, 0) ** 3 -
        0.0018771192 * Math.max(x - 15.294313, 0) ** 3 -
        0.0015062246 * Math.max(x - 15.744065, 0) ** 3 +
        0.00082022983 * Math.max(x - 16.193817, 0) ** 3 -
        0.00029485706 * Math.max(x - 16.643569, 0) ** 3 +
        0.00060587897 * Math.max(x - 17.093321, 0) ** 3 +
        0.0010940752 * Math.max(x - 17.543074, 0) ** 3;
    return value;
}
exports.no_genotype_age_scd_spline = no_genotype_age_scd_spline;
function no_genotype_nsvt_scd_spline(x) {
    return 1.055781637 * x;
}
exports.no_genotype_nsvt_scd_spline = no_genotype_nsvt_scd_spline;
function no_genotype_syncope_scd_spline(x) {
    return 2.002072082 * x;
}
exports.no_genotype_syncope_scd_spline = no_genotype_syncope_scd_spline;
function no_genotype_genotype_scd_spline(x) {
    return 0;
}
exports.no_genotype_genotype_scd_spline = no_genotype_genotype_scd_spline;
function no_genotype_age_oth_spline(x) {
    let value = 1.2556848
        - 0.41210237 * x
        + 0.022546978 * Math.max(x - 0.45249005, 0) ** 3
        - 0.032253322 * Math.max(x - 0.90224225, 0) ** 3
        + 0.021971447 * Math.max(x - 1.3519944, 0) ** 3
        - 0.015173718 * Math.max(x - 1.8017466, 0) ** 3
        + 0.0064286581 * Math.max(x - 2.2514988, 0) ** 3
        - 0.0045769696 * Math.max(x - 2.701251, 0) ** 3
        + 0.0011369458 * Math.max(x - 3.1510032, 0) ** 3
        - 0.0011218285 * Math.max(x - 3.6007554, 0) ** 3
        - 0.000112082 * Math.max(x - 4.0505076, 0) ** 3
        - 0.00019283669 * Math.max(x - 4.5002598, 0) ** 3
        - 0.0003018066 * Math.max(x - 4.950012, 0) ** 3
        + 2.2567184e-5 * Math.max(x - 5.3997642, 0) ** 3
        - 0.00011730883 * Math.max(x - 5.8495164, 0) ** 3
        + 2.9251356e-6 * Math.max(x - 6.2992686, 0) ** 3
        + 6.8766369e-5 * Math.max(x - 6.7490208, 0) ** 3
        - 3.4577542e-5 * Math.max(x - 7.198773, 0) ** 3
        + 0.00018183354 * Math.max(x - 7.6485252, 0) ** 3
        - 3.2039427e-5 * Math.max(x - 8.0982774, 0) ** 3
        + 0.00024373467 * Math.max(x - 8.5480296, 0) ** 3
        + 5.8357118e-5 * Math.max(x - 8.9977818, 0) ** 3
        + 0.00017599358 * Math.max(x - 9.447534, 0) ** 3
        + 0.0001797059 * Math.max(x - 9.8972862, 0) ** 3
        + 6.2203499e-5 * Math.max(x - 10.347038, 0) ** 3
        + 0.0002630895 * Math.max(x - 10.796791, 0) ** 3
        - 2.596397e-5 * Math.max(x - 11.246543, 0) ** 3
        + 0.00025041989 * Math.max(x - 11.696295, 0) ** 3
        - 4.585296e-5 * Math.max(x - 12.146047, 0) ** 3
        + 0.00022911074 * Math.max(x - 12.595799, 0) ** 3
        - 3.1166354e-5 * Math.max(x - 13.045552, 0) ** 3
        + 0.00011698762 * Math.max(x - 13.495304, 0) ** 3
        - 1.3930075e-6 * Math.max(x - 13.945056, 0) ** 3
        + 4.9303845e-5 * Math.max(x - 14.394808, 0) ** 3
        + 2.4453737e-5 * Math.max(x - 14.84456, 0) ** 3
        - 1.8680796e-5 * Math.max(x - 15.294313, 0) ** 3
        + 8.708712e-6 * Math.max(x - 15.744065, 0) ** 3
        - 1.7404542e-5 * Math.max(x - 16.193817, 0) ** 3
        + 2.7861472e-5 * Math.max(x - 16.643569, 0) ** 3
        - 3.0711824e-5 * Math.max(x - 17.093321, 0) ** 3
        + 3.7610188e-5 * Math.max(x - 17.543074, 0) ** 3;
    return value;
}
exports.no_genotype_age_oth_spline = no_genotype_age_oth_spline;



// WEBPACK FOOTER //
// ./demo/pages/components/primacy-cal-js/no_genotype_spline_functions.js